import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
  server: {
    SERVICE_URL: z.string().optional(),
    SERVICE_USERNAME: z.string().optional(),
    SERVICE_PASSWORD: z.string().optional(),
    ACCOUNT_SERVICE_URL: z.string().optional(),
    ACCOUNT_SERVICE_USERNAME: z.string().optional(),
    ACCOUNT_SERVICE_PASSWORD: z.string().optional(),
    CART_SERVICE_URL: z.string().optional(),
    CART_SERVICE_USERNAME: z.string().optional(),
    CART_SERVICE_PASSWORD: z.string().optional(),
    CRM_SERVICE_URL: z.string().optional(),
    CRM_SERVICE_USERNAME: z.string().optional(),
    CRM_SERVICE_PASSWORD: z.string().optional(),
    PRODUCT_SERVICE_URL: z.string().optional(),
    PRODUCT_SERVICE_USERNAME: z.string().optional(),
    PRODUCT_SERVICE_PASSWORD: z.string().optional(),
    STOCK_SERVICE_URL: z.string().optional(),
    STOCK_SERVICE_USERNAME: z.string().optional(),
    STOCK_SERVICE_PASSWORD: z.string().optional(),
  },
  runtimeEnv: process.env,
});

export default env;
